import React from "react";
import { Alert, AlertTitle, Box, Typography } from "@mui/material";
import {
  anyPartCompleted,
  isDonePart,
  joinNames,
  partName,
  realParts,
  shortLabel,
  unfinishedParts,
} from "../utils/policyParts";

/**
 * Shown above the stepper when an edit opens on a policy where SOME parts are
 * already bought: those stay as they are and only the unfinished ones re-run.
 *
 * @param {object} policy the policy being edited (carries `parts`)
 */
const CompletedPartsNotice = ({ policy }) => {
  if (!anyPartCompleted(policy)) return null;
  const todo = unfinishedParts(policy);
  if (!todo.length) return null;

  const bought = realParts(policy).filter(
    (p) => isDonePart(p) && p.kind !== "withPart" && p.status !== "cancelled"
  );
  if (!bought.length) return null;

  // A Brisk PA waiting on a part that will re-run simply follows it.
  const followers = todo.filter(
    (p) => p.kind === "brisk" && todo.some((t) => t.key === p.dependsOn)
  );
  const lead = todo.filter((p) => !followers.includes(p));

  return (
    <Box sx={{ px: "5px", pt: 2 }}>
      <Alert
        severity="warning"
        sx={{
          alignItems: "flex-start",
          backgroundColor: "#FFFAEB",
          border: "1px solid #FEDF89",
          color: "#B54708",
          "& .MuiAlert-icon": { color: "#B54708" },
        }}
      >
        <AlertTitle sx={{ fontWeight: 700, color: "#B54708" }}>
          {joinNames(bought, { withCompany: true })}{" "}
          {bought.length > 1 ? "are" : "is"} already bought — only{" "}
          {joinNames(lead.length ? lead : followers)} will be re-submitted
        </AlertTitle>
        <Typography sx={{ fontSize: 13 }}>
          Changes won&apos;t affect the {joinNames(bought)}{" "}
          {bought.length > 1 ? "policies" : "policy"}.
        </Typography>
        {lead.length > 0 &&
          followers.map((p) => (
            <Typography key={p.key} sx={{ fontSize: 13 }}>
              {partName(p)} follows {shortLabel(p.dependsOn)}.
            </Typography>
          ))}
      </Alert>
    </Box>
  );
};

export default CompletedPartsNotice;
